import type { Howl } from 'howler'
import { settings } from '../../engine/settings-sidecar'
import { soundsGeneric } from '../../engine/soundsGeneric-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'

function play(keys: string[], volume: number, loop: boolean, cb?: () => void) {
  return soundsGeneric.playAmbientUnmanaged(
    voyageSounds.getMusicPath() + rando.sample(keys),
    volume,
    loop,
    cb,
  )
}

let _fire: Howl | null = null
//let _fireId: number = -1
export function updateFire(doPlay: boolean) {
  if (settings.get().muteSound) {
    doPlay = false
  }

  // console.log('update fire', doPlay)

  if (doPlay) {
    // console.log('do play', doPlay)
    if (_fire) {
      return
    }
    console.log('play buring')
    _fire = play(
      ['FireBurningLoop1', 'FireBurningLoop2'], //, 'FireBurningLoop3'],
      0.8,
      false,
      () => {
        console.log('fire looped')
        soundsGeneric.stopAmbientUnmanaged(_fire)
        _fire = null
      },
    )
  } else {
    // console.log('stop buring')
    soundsGeneric.stopAmbientUnmanaged(_fire)
    _fire = null
  }
}

let _reactor: Howl | null = null

export function updateReactor(doPlay: boolean) {
  if (settings.get().muteSound) {
    doPlay = false
  }

  // console.log('update fire', doPlay)

  if (doPlay) {
    // console.log('do play', doPlay)
    if (_reactor) {
      return
    }

    _reactor = play(
      [
        'SpaceShip_EngineRoom_01_Loop',
        'SpaceShip_EngineRoom_01_Variation_Loop',
      ],
      1.5,
      false,
      () => {
        soundsGeneric.stopAmbientUnmanaged(_reactor)
        _reactor = null
      },
    )
  } else {
    soundsGeneric.stopAmbientUnmanaged(_reactor)
    _reactor = null
  }
}

// function playManaged(keys: string[]) {
//   soundsGeneric.playAmbient(voyageSounds.getMusicPath() + rando.sample(keys))
// }
// export function playInSpace() {
//   playManaged(
//     ['SpaceShip_EngineRoom_01_Loop', 'SpaceShip_EngineRoom_01_Variation_Loop'],
//     //1,
//     //false,
//   )
// }
